import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";

function MarksEvaluation() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : Number(localStorage.getItem("centerId"));

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      evaluationCriteriaTypeId: "",
      classSectionId: "",
      sectionSubjectId: "",
      studentId: "",
      performanceEvaluationMarkDetails: [],
    },
  });

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [termsData, setTermsData] = useState([]);
  const [classSectionsData, setClassSectionsData] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);
  const [studentsData, setStudentsData] = useState([]);
  const [studentMarksData, setStudentMarksData] = useState([]);

  const fetchTermsByOrgId = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllEvaluationCriteriaType?OrganizationId=${organizationId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setTermsData(response?.evaluationTypes);
    } catch (error) {
      console.error("Error fetching terms:", error);
    }
  };
  const fetchClassSectionsByCenterId = async () => {
    if (centerId) {
      try {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${centerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setClassSectionsData(response);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    } else {
      setClassSectionsData([]);
    }
  };
  const fetchSubjectsByClassSectionId = async () => {
    const classSectionId = watch("classSectionId")?.value;
    if (classSectionId) {
      try {
        const response = await get(
          `StudentEvaluation/GetSubjectByClassSectionId?ClassSectionId=${classSectionId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSubjectsData(response.subjects || []);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    } else {
      setSubjectsData([]);
    }
  };
  const fetchStudentsByIds = async () => {
    const classSectionId = watch("classSectionId")?.value;
    const sectionSubjectId = watch("sectionSubjectId")?.value;
    if (classSectionId && sectionSubjectId) {
      try {
        const response = await get(
          `StudentEvaluation/GetStudentByClassSectionIdAndSubjectId?ClassSectionId=${classSectionId}&SectionSubjectId=${sectionSubjectId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setStudentsData(response?.students || []);
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    } else {
      setStudentsData([]);
    }
  };
  const fetchEvaluationData = async () => {
    const formdata = {
      evaluationCriteriaTypeId: watch("evaluationCriteriaTypeId")?.value,
      studentId: watch("studentId")?.value || 0,
      classSectionId: watch("classSectionId")?.value,
      sectionSubjectId: watch("sectionSubjectId")?.value,
      createdBy: localStorage.getItem("userId"),
    };

    try {
      const response = await post(
        `StudentEvaluation/GetStudentMarks`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStudentMarksData(response?.studentMarks || []);
    } catch (error) {
      console.error("Error fetching evaluation:", error);
    }
  };
  // Fetch evaluation data based on selected criteria
  useEffect(() => {
    fetchTermsByOrgId();
    fetchClassSectionsByCenterId();
    fetchSubjectsByClassSectionId();
    fetchStudentsByIds();
    if (
      watch("evaluationCriteriaTypeId") &&
      watch("classSectionId") &&
      watch("sectionSubjectId")
    ) {
      fetchEvaluationData();
    } else {
      setStudentMarksData([]);
    }
  }, [
    watch("evaluationCriteriaTypeId"),
    watch("classSectionId"),
    watch("sectionSubjectId"),
    watch("studentId"),
    token,
  ]);

  const handleTermChange = (selectedOption) => {
    setValue("evaluationCriteriaTypeId", selectedOption);
    setValue("classSectionId", null);
    setValue("sectionSubjectId", null);
    setValue("studentId", null);
  };

  const handleClassSectionChange = (selectedOption) => {
    setValue("classSectionId", selectedOption);
    setValue("sectionSubjectId", null);
    setValue("studentId", null);
  };

  const handleSubjectChange = (selectedOption) => {
    setValue("sectionSubjectId", selectedOption);
    setValue("studentId", null);
  };

  const handleStudentChange = (selectedOption) => {
    setValue("studentId", selectedOption);
  };

  const saveData = async (data) => {
    console.log(data);
    const formdata = studentMarksData.map((item, index) => ({
      studentSectionSubjectId:
        data.performanceEvaluationMarkDetails[index].studentSectionSubject,
      id: data.performanceEvaluationMarkDetails[index].id,
      evaluationCriteriaClassWeightageId:
        data.performanceEvaluationMarkDetails[index]
          .evaluationCriteriaClassWeightageId,
      evaluationCriteriaTypeId: watch("evaluationCriteriaTypeId")?.value,
      marksObtained: data.performanceEvaluationMarkDetails[index].marks,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
    }));

    try {
      const response = await post(
        `StudentEvaluation/AddUpdateStudentMarks`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        fetchEvaluationData();
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Marks Evaluation</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex mb-2">
                <h4 className="fs-8 text-secondary">Select Pupil</h4>
              </div>
              <div className="row g-3">
                <div className="col-md-3">
                  <label className="form-label">
                    Term<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="evaluationCriteriaTypeId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={termsData.map((term) => ({
                          value: term.id,
                          label: term.type,
                        }))}
                        onChange={handleTermChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.evaluationCriteriaTypeId && (
                    <small className="text-danger">
                      {errors.evaluationCriteriaTypeId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Year Group - Section
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="classSectionId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classSectionsData.map((classSection) => ({
                          value: classSection.id,
                          label: classSection.name,
                        }))}
                        onChange={handleClassSectionChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.classSectionId && (
                    <small className="text-danger">
                      {errors.classSectionId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Subject<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="sectionSubjectId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subjectsData.map((subject) => ({
                          value: subject.id,
                          label: subject.name,
                        }))}
                        onChange={handleSubjectChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.sectionSubjectId && (
                    <small className="text-danger">
                      {errors.sectionSubjectId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Pupil<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="studentId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={studentsData.map((student) => ({
                          value: student.id,
                          label: student.name,
                        }))}
                        onChange={handleStudentChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.studentId && (
                    <small className="text-danger">
                      {errors.studentId.message}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex mb-2">
                <h4 className="fs-8 text-secondary">Marks Entry</h4>
              </div>
              <table className="table table-bordered custom-table m-0">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th hidden>Id</th>
                    <th hidden>Student Section Subject</th>
                    <th hidden>Student weitage Id</th>
                    <th>Student Name</th>
                    {/* <th>Evaluation Criteria</th> */}
                    <th>Total Marks</th>
                    <th>Obtained Marks</th>
                  </tr>
                </thead>
                <tbody>
                  {studentMarksData.length > 0 ? (
                    studentMarksData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td hidden>
                          <input
                            type="hidden"
                            value={item.id}
                            {...register(
                              `performanceEvaluationMarkDetails[${index}].id`
                            )} // Register studentSectionSubjectId
                          />
                        </td>
                        <td hidden>
                          <input
                            type="hidden"
                            value={item.studentSectionSubject}
                            {...register(
                              `performanceEvaluationMarkDetails[${index}].studentSectionSubject`
                            )} // Register studentSectionSubjectId
                          />
                        </td>
                        <td hidden>
                          <input
                            type="hidden"
                            value={item.evaluationCriteriaClassWeightageId}
                            {...register(
                              `performanceEvaluationMarkDetails[${index}].evaluationCriteriaClassWeightageId`
                            )} // Register studentSectionSubjectId
                          />
                        </td>
                        <td>{item.studentName}</td>
                        {/* <td>{item.criteria}</td> */}
                        <td>{item.totalMarks}</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            {...register(
                              `performanceEvaluationMarkDetails[${index}].marks`
                            )}
                            defaultValue={item.marks || ""}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        There are no records to display
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="col-md-12 mt-3">
                <button type="submit" className="btn btn-primary btn-sm">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default MarksEvaluation;
